import { render, staticRenderFns } from "./PaymentStatusChip.vue?vue&type=template&id=0d6384cc&"
import script from "./PaymentStatusChip.vue?vue&type=script&lang=ts&"
export * from "./PaymentStatusChip.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports